import {
  LOGIN_ACTION,
  SIGNUP_ACTION,
  FORGOT_PASSWORD_ACTION,
  RESET_PASSWORD_ACTION,
  RESEND_ACTIVATION_ACTION,
  LOGOUT_ACTION,
  FETCH_COUNTRIES_REQUEST,
  FETCH_COUNTRIES_FAILURE,
  FETCH_COUNTRIES_SUCCESS
} from "../../common/constants";

export const loginAction = function(loginInfo) {
  return { type: "LOGIN_ACTION", loginInfo };
};

export const signupAction = function(signupInfo) {
  return { type: "SIGNUP_ACTION", signupInfo };
};

export const forgotPasswordAction = function(forgotPasswordInfo) {
  return { type: "FORGOT_PASSWORD_ACTION", forgotPasswordInfo };
};

export const resetPasswordAction = function(forgotPasswordInfo) {
  return { type: "RESET_PASSWORD_ACTION", forgotPasswordInfo };
};

export const resendActivationAction = function(resendActivationInfo) {
  return { type: "RESEND_ACTIVATION_ACTION", resendActivationInfo };
};

export const logoutAction = () => {
  return { type: "LOGOUT_ACTION" };
};


export const fetchCountriesRequest = () => ({
  type: FETCH_COUNTRIES_REQUEST
});

export const fetchCountriesSuccess = (countries) => ({
  type: FETCH_COUNTRIES_SUCCESS,
  payload: countries
});

export const fetchCountriesFailure = (error) => ({
  type: FETCH_COUNTRIES_FAILURE,
  payload: error
});


// WEBPACK FOOTER //
// ./src/Containers/Login/actions.js